const initState = {
	user: null,
	/* wordpress: {
		username: null,
		password: null,
	}, */
};

const initGetters = {
	user: state => state.user,
	role: (state) => {
		if (state.user) {
			const jwtToken = localStorage.getItem('jwtToken');

			if (jwtToken) {
				const jwtData = jwtToken.split('.')[1];
				const { role } = JSON.parse(window.atob(jwtData.replace(/-/g, '+').replace(/_/g, '/')));

				return role;
			}
		}

		return null;
	},
	/* wpuser: (state) => {
		if (state.wordpress.username && state.wordpress.password) {
			return state.wordpress;
		}

		return null;
	}, */
};

const initMutations = {
	//  USER
	LOGIN(state, data) {
		localStorage.setItem('jwtToken', data.jwt_token);
		localStorage.setItem('refreshToken', JSON.stringify(data.refresh_token));

		state.user = data.user;
	},
	LOGOUT(state) {
		state.user = null;

		localStorage.setItem('jwtToken', '');
		localStorage.setItem('refreshToken', '');
	},
	/* LOGINWP(state, data) {
		state.wordpress.username = data.username;
		state.wordpress.password = data.password;
	}, */
	LOGOUTWP(state) {
		state.wordpress.username = null;
		state.wordpress.password = null;
	},
};

const initActions = {
	async login({ commit }, params) {
		const response = await this.$http.post('auth/loginUser', params, { headers: { byPassAuth: true } });

		if (response && response.data && response.data.ok) {
			const jwtData = response.data.jwt_token.split('.')[1];
			const { role } = JSON.parse(
				window.atob(
					jwtData.replace(/-/g, '+').replace(/_/g, '/'),
				),
			);

			switch (role) {
			case 'admin':
			case 'editor':
			case 'superadmin':
				commit('LOGIN', response.data);
				return true;
			default:
				return false;
			}
		}

		return false;
	},
	async logout({ commit }) {
		commit('LOGOUT');
		window.location.reload();
		return true;
	},
};

export default {
	state: initState,
	getters: initGetters,
	actions: initActions,
	mutations: initMutations,
};
